import { useStaticQuery, graphql } from "gatsby";
// @ts-ignore
import { resolveManual } from "@dataResolvers";

const query = graphql`
  query allManualsQuery {
    craft {
      products: entries(
        section: ["manuals", "manualsComposableEntries"]
        siteId: ["not", "-1"]
        type: ["product"]
      ) {
        id
        siteId
        language
        siteHandle
        ... on Craft_product_Entry {
          userTitle
          productVariant
          productFamily
          productIcon {
            uid
            url
            width
            height
            focalPoint
            hasFocalPoint
          }
          productCategory {
            id
            title
            ... on Craft_productCategories_Category {
              role
            }
          }
        }
      }
    }
  }
`;

const dataResolver = ({ craft }) => {
  return craft.products.map(product => resolveManual(product));
};

let cache;

const useData = () => {
  const response = useStaticQuery(query);

  if (cache) {
    return cache;
  }

  cache = dataResolver(response);
  return cache;
};

export default useData;
